import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import HomePage from "./pages/home/Home";
import SignupPage from "./pages/auth/Signup";
import LoginPage from "./pages/auth/Login";
import VideosPage from "./components/Videos";
import ProfilePage from "./pages/profile/ProfilePage";
import LevelsPage from "./pages/levels/LevelsPage";
import PhaseSelection from "./pages/phases/Phases";
import ResultPage from "./pages/result/ResultPage";

const App = () => {

  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/register" element={<SignupPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/me" element={<ProfilePage />} />
        <Route
          path="/videos"
          element={
            <VideosPage />
          }
        />
        <Route
          path="/phase-selection"
          element={
            <PhaseSelection />
          }
        />
        <Route
          path="/levels"
          element={
            <LevelsPage />
          }
        />
        <Route
          path="/result"
          element={
            <ResultPage />
          }
        />

        

      </Routes>
    </Router>
  );
};

export default App;
